import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";

const undergraduatePerks = [
  { img: "/SAPImages/pricing/profile.png", perk: "Profile Evaluation" },
  {
    img: "/SAPImages/pricing/universityshortlist.png",
    perk: "University Shortlisting",
  },
  { img: "/SAPImages/pricing/testprep.png", perk: "Test Preparation" },
  {
    img: "/SAPImages/pricing/timeline.png",
    perk: "Application Strategy & Timeline",
  },
  { img: "/SAPImages/pricing/sop.png", perk: "SOP & Essays" },
  { img: "/SAPImages/pricing/cv.png", perk: "CV/Resume" },
  { img: "/SAPImages/pricing/lor.png", perk: "LOR Guidance" },
  {
    img: "/SAPImages/pricing/schorlarship.png",
    perk: "Scholarships & Financial Aid",
  },
  {
    img: "/SAPImages/pricing/video.png",
    perk: "Mock Interviews & Video Essays",
  },
  { img: "/SAPImages/pricing/visa.png", perk: "Visa & Pre-Departure" },
];

const postgraduatePerks = [
  {
    img: "/SAPImages/pricing/universityshortlist.png",
    perk: "University Shortlisting",
  },
  { img: "/SAPImages/pricing/lor.png", perk: "LOR Guidance" },
  { img: "/SAPImages/pricing/sop.png", perk: "Essay Drafting" },
  {
    img: "/SAPImages/pricing/schorlarship.png",
    perk: "Scholarships & Financial Aid",
  },
  {
    img: "/SAPImages/pricing/video.png",
    perk: "Mock Interviews & Video Essays",
  },
  { img: "/SAPImages/pricing/visa.png", perk: "Visa & Pre-Departure" },
];

function MoreInfoPopup({ open, onClose, pkg }) {
  const navigate = useNavigate();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  if (!open) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-[1100] bg-black/40">
      <div className="relative bg-white rounded-2xl max-w-3xl w-full max-h-[90vh] overflow-y-auto scrollbar-hide">
        {/*  Close Button */}
        <button
          onClick={onClose}
          aria-label="Close"
          className="absolute top-4 right-4 w-9 h-9 flex items-center justify-center rounded-full   shadow-sm  transition-all z-20"
        >
          <img
            src="/SAPImages/pricing/close.png"
            alt="Close"
            className="w-10 h-10 object-contain"
          />
        </button>

        {/* Top Background Section */}
        <div
          style={{
            width: "100%",
            minHeight: "300px",
            backgroundImage: "url('/SAPImages/pricing/Frame 1597881245.png')",
            backgroundSize: "cover",
            backgroundPosition: "center",
            padding: "20px",
            display: "grid",
            gridTemplateColumns: isSmallScreen ? "1fr" : "1fr 350px",
            alignItems: "start",
            gap: "20px",
            borderBottomLeftRadius: "50px",
            borderBottomRightRadius: "50px",
          }}
        >
          {/* Left Text Section */}
          <div
            style={{ display: "flex", flexDirection: "column", gap: "10px" }}
          >
            {/* Header: Image + Package Name */}
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <img
                src="/SAPImages/pricing/Group 1171283405.png"
                alt={pkg?.package_name || "Package"}
                style={{ width: "44px", height: "45px", objectFit: "contain" }}
              />
              <span
                style={{
                  fontFamily: "Inter",
                  fontWeight: 400,
                  fontSize: "24px",
                  lineHeight: "100%",
                  color: "#fff",
                }}
              >
                {pkg?.package_name || "Package name"}
              </span>
            </div>

            <div className="flex flex-start gap-3">
              {/* Price */}
              <h2
                style={{
                  fontFamily: "Inter",
                  fontWeight: 700,
                  fontSize: "32px",
                  lineHeight: "100%",
                  color: "#fff",
                  marginTop: "30px",
                }}
              >
                INR {pkg?.original_price || 50000}
              </h2>
              <p class="font-Siromi mt-10 text-white  font-normal text-[14px] leading-[100%] tracking-[0%] text-center">
                Subscription
              </p>
            </div>
            {/* Program Info */}
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <img
                src="/SAPImages/pricing/Vector.png"
                alt="Program icon"
                style={{ width: "20px", height: "20px", objectFit: "contain" }}
              />
              <h2 className="font-altisunisa no-wrap font-bold text-[14px] leading-[100%] text-white m-0 align-middle">
                {pkg?.sub_service_id == 13
                  ? "Scholars Undergraduate Admissions Program"
                  : "Scholars Postgraduate Admissions Program"}
              </h2>
            </div>
          </div>

          {/* Right Image */}
          {!isSmallScreen && (
            <img
              src="/SAPImages/pricing/vnu_m715_18-removebg-preview 1.png"
              alt="Side visual"
              style={{
                width: "350px",
                height: "228px",
                objectFit: "contain",
                justifySelf: "start",
              }}
            />
          )}
        </div>

        {/* White Card Overlapping Section */}
        <div className="flex justify-center -mt-[70px] bg-transparent">
          <div className="w-[95%] bg-white rounded-xl shadow-[0px_2px_5px_0px_#CFA4E866] p-3 flex flex-col md:flex-row gap-6 md:gap-8 border border-[#E6D5F3]">
            {/* Left Column - Perks */}
            <div className="md:flex-[0.4] flex-1  rounded-xl p-5  flex flex-col justify-between">
              <div>
                <div className="flex items-center gap-2 mb-6">
                  <img
                    src="/SAPImages/pricing/star.svg"
                    alt="Perks Icon"
                    className="w-6 h-6 object-contain"
                  />
                  <h2 className="text-[20px] font-bold bg-gradient-to-r from-[#B32A9E] to-[#8230B3] bg-clip-text text-transparent font-altisunisa">
                    Perks
                  </h2>
                </div>

                <ul className="flex flex-col gap-3 list-none w-full">
                  {(pkg?.sub_service_id == 13
                    ? undergraduatePerks
                    : postgraduatePerks
                  ).map((item, idx) => (
                    <li
                      key={idx}
                      className="flex items-center gap-3 w-full text-left"
                    >
                      <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center bg-[#FCEEFF] rounded-md">
                        <img
                          src={item.img}
                          alt=""
                          className="w-12 h-12 object-contain"
                        />
                      </div>
                      <span className="text-[#333333] text-[15px] font-normal font-altisunisa leading-[1.4]">
                        {item.perk}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Right Column - Payment Plans */}
            <div className="md:flex-[0.6] flex-1 bg-[#FCF9FF] rounded-xl p-5 border border-[#E6D5F3] flex flex-col justify-between">
              <div>
                <div className="flex items-center gap-2 mb-4">
                  <img
                    src="/SAPImages/pricing/star.svg"
                    alt="Payment Icon"
                    className="w-6 h-6 object-contain"
                  />
                  <h2
                    className="text-[20px] font-normal bg-gradient-to-r from-[#B32A9E] to-[#8230B3] bg-clip-text text-transparent"
                    style={{
                      fontFamily: "Inter",
                      verticalAlign: "middle",
                      lineHeight: "100%",
                    }}
                  >
                    Flexible Payment Plans
                  </h2>
                </div>

                {/* Steps */}
                {pkg?.installments?.length > 0 ? (
                  <ul className="flex flex-col gap-3 list-none w-full">
                    {pkg.installments.map((inst, idx) => (
                      <li
                        key={idx}
                        className="grid grid-cols-[28px_1fr] items-start w-full"
                      >
                        {/* Timeline column */}
                        <div className="relative flex flex-col items-center">
                          {/*  add top connector for continuity */}
                          {idx > 0 && (
                            <div
                              aria-hidden="true"
                              className="w-[2px] flex-1"
                              style={{
                                minHeight: "12px",
                                backgroundImage:
                                  "repeating-linear-gradient(to bottom, #CFA4E8 0px, #CFA4E8 4px, transparent 4px, transparent 8px)",
                              }}
                            />
                          )}

                          {/* Circle */}
                          <div className="relative w-5 h-5 flex items-center justify-center z-10 my-1">
                            {/* outer glow */}
                            <div
                              className="absolute inset-0 rounded-full bg-gradient-to-b from-[#DDA4FF] to-[#7A1FBF] opacity-40 blur-[10px]"
                              aria-hidden="true"
                            ></div>
                            {/* inner gradient circle */}
                            <div className="w-4 h-4 rounded-full bg-gradient-to-b from-[#B32A9E] to-[#8230B3] flex items-center justify-center shadow-md">
                              <div className="w-1.5 h-1.5 rounded-full bg-white"></div>
                            </div>
                          </div>

                          {/* bottom connector for continuity  */}
                          {idx < pkg.installments.length - 1 && (
                            <div
                              aria-hidden="true"
                              className="w-[2px] flex-1"
                              style={{
                                minHeight: "24px",
                                backgroundImage:
                                  "repeating-linear-gradient(to bottom, #CFA4E8 0px, #CFA4E8 4px, transparent 4px, transparent 8px)",
                              }}
                            />
                          )}
                        </div>

                        {/* Content box */}
                        <div className="bg-white rounded-lg shadow-[0_2px_6px_#CFA4E866] px-4 py-3 flex-1">
                          <p className="text-[#6B21A8] font-bold text-[18px] font-altisunisa inline">
                            INR {inst[`installment_${idx + 1}_amount`]}
                          </p>
                          <span className="text-[#333333] text-[13px] font-normal font-altisunisa ml-1">
                            /{inst[`installment_${idx + 1}_description`]}
                          </span>
                        </div>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p className="text-[#333333] text-[14px] font-normal font-altisunisa mt-2">
                    This package does not have a payment plan, please pay the
                    full amount upfront.
                  </p>
                )}
              </div>

              {/* Secure Payment */}
              <div className="border-l-8 border-[#FFCA00] mt-6 bg-[#FFF6E0]  rounded-lg px-4 py-2 flex items-start gap-1">
                <img
                  src="/SAPImages/pricing/secure.svg"
                  alt="Secure Icon"
                  className="w-10 h-10 "
                />
                <p className="text-[#333333] text-[13px] font-normal leading-snug font-altisunisa">
                  <span className="font-semibold">100% Secure Payment</span> -
                  All transactions are protected with the latest encryption
                  technology, giving you complete peace of mind while making
                  payments.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Enroll Button */}
        <div className="my-4 flex justify-center items-center">
          <button
            disabled={pkg.is_enrolled === 1}
            onClick={() => {
              onClose();
              navigate("/sap/checkout", {
                state: {
                  package_name: pkg?.package_name,
                  original_price: pkg?.original_price,
                  sub_service_id: pkg?.sub_service_id,
                  installments: pkg?.installments,
                },
              });
            }}
            style={{
              background: pkg.is_enrolled === 1 ? "#B0A4B9" : "#572575",
            }}
            className="flex items-center justify-center gap-2 bg-[#572575] text-white font-semibold text-base py-2 px-28 rounded-lg shadow-md hover:bg-[#4b1e65] transition-all"
          >
            <img
              src="/SAPImages/pricing/ic_round-co-present.png"
              alt="Enroll"
              className="w-5 h-5"
            />
            Enroll Now
          </button>
        </div>
      </div>
    </div>
  );
}

export default MoreInfoPopup;
